"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getForecast = exports.getGrowth = exports.getTopNAndOthers = exports.negate = exports.isTopN = void 0;
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var isTopN = function (field, lmt) { return function (sS, idx) {
    var _a;
    return (!!((_a = sS.toolAnalysis) === null || _a === void 0 ? void 0 : _a[field]) && (!lmt || idx < lmt));
}; };
exports.isTopN = isTopN;
var negate = function (fn) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return !fn.apply(void 0, __spreadArray([], __read(args), false));
}; };
exports.negate = negate;
var getTopNAndOthers = function (sStats, field, lmt) {
    var sStatsCopy = __spreadArray([], __read(sStats), false);
    sStatsCopy.sort(function (a, b) { var _a, _b; return (((_a = b.toolAnalysis) === null || _a === void 0 ? void 0 : _a[field]) || 0) - (((_b = a.toolAnalysis) === null || _b === void 0 ? void 0 : _b[field]) || 0); });
    var topNFn = (0, exports.isTopN)(field, lmt);
    var otherSS = sStatsCopy.filter(function (sS, idx) { var _a; return !topNFn(sS, idx) && !!((_a = sS.toolAnalysis) === null || _a === void 0 ? void 0 : _a[field]); });
    var other = otherSS.length
        ? { count: otherSS.length, spend: (0, sumBy_1.default)(otherSS, 'toolAnalysis.last12MonthSpend'), amount: (0, sumBy_1.default)(otherSS, "toolAnalysis.".concat(field)) }
        : null;
    return [sStatsCopy.filter(topNFn), other];
};
exports.getTopNAndOthers = getTopNAndOthers;
var getGrowth = function (audit) { return 1 + ((audit === null || audit === void 0 ? void 0 : audit.summary.growthEstimationY1) || 0) * 0.5; };
exports.getGrowth = getGrowth;
var getForecast = function (sS) {
    var _a, _b;
    return ((1 + (((_a = sS.auditSummary) === null || _a === void 0 ? void 0 : _a.growthEstimationY1) || 0) * 0.5) * (((_b = sS.toolAnalysis) === null || _b === void 0 ? void 0 : _b.activeAnnualSpend) || 0));
};
exports.getForecast = getForecast;
